export default "__VITE_ASSET__7b4f8137__"